var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NavigationWrapper',{scopedSlots:_vm._u([{key:"breadcrumbs",fn:function(){return [_c('b-breadcrumb-item',{attrs:{"to":"/team"}},[_vm._v("Settings")]),_c('b-breadcrumb-item',{attrs:{"active":""}},[_vm._v("Members")])]},proxy:true}])},[_c('h1',{staticClass:"mb-3"},[_vm._v("Members")]),_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"Card-table Card-table-hoverable"},[_c('b-card-text',[_c('b-table',{attrs:{"responsive":"","small":"","fields":[
              {
                key: 'email',
                label: 'Email',
                sortable: true,
              },
              {
                key: 'name',
                label: 'Name',
                sortable: true,
              },
              {
                key: 'handle',
                label: 'Handle',
                sortable: true,
                formatter: function formatter(value, key, item) {
                  return ("@" + value);
                },
              },
              {
                key: 'role.name',
                label: 'Role',
                sortable: true,
              } ],"items":Object.values(_vm.teamMembers)},on:{"row-clicked":_vm.goToMember},scopedSlots:_vm._u([{key:"cell(email)",fn:function(ref){
            var item = ref.item;
return [_vm._v("\n              "+_vm._s(item.email)+"\n              "),_c('CardTableLinkIndicator')]}}])})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }